<template lang="pug">

    campaign-form(
        ref="form"
        v-bind:segment='segment'
        v-bind:purchaser-models='purchaserModels'
        v-model="model"
    )

</template>

<script>
    import CampaignForm from './Form.vue'

    export default {
        name: 'campaign-update-form-component',

        components: { CampaignForm },

        computed: {

            model: {
                get() { return this.value },
                set(value) { this.$emit('input', value)}
            }

        },

        methods: {

            persist() {
                return this.$store.dispatch('campaigns/update', { model: this.value })
            },

            validate() {
                return this.$refs.form.validate()
            },

        },

        props: {

            segment: {
                type: [Boolean, String],
                default: true
            },

            purchaserModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        }

    }

</script>
